/**
 * Motivo legible de un fallo de la route-optimization API.
 *
 * Por qué existe: la API es FastAPI y reporta el porqué en **`detail`**, no en
 * `message`. Leer solo `message` deja siempre el mensaje genérico ("entrada
 * inválida") y esconde la causa real — que en un `422` de Pydantic es la lista
 * de campos que no validaron, exactamente lo que hace falta para arreglarlo.
 *
 * `detail` llega en dos formas:
 * - **string**, cuando el motor no pudo resolver el problema;
 * - **lista de errores de validación** (`{loc, msg, type}`), cuando el cuerpo no
 *   cumple el contrato.
 */
export function apiErrorDetail(err: unknown): string {
  const e = err as { error?: { message?: string; detail?: unknown } };
  if (e?.error?.message) return e.error.message;

  const detail = e?.error?.detail;
  if (typeof detail === 'string') return detail;

  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        const item = d as { msg?: string; loc?: unknown[] };
        // `loc[0]` es siempre "body": se descarta para dejar la ruta del campo.
        const loc = (item.loc ?? []).slice(1).join('.');
        return [loc, item.msg].filter(Boolean).join(': ');
      })
      .filter(Boolean)
      .slice(0, 3)
      .join(' · ');
  }
  return '';
}
